import React from "react";
import classNames from "classnames";
import { BemHelper } from "../../utils/BemHelper";

// Image
import {
  TemplateGalleryIcon,
  InvoiceQuickToolsIcon,
  ContractsIcon,
  EmailsIcon,
  ArrowQuickToolsIcon,
} from "@/icons/primary";

type Props = {
  type: "template-gallery" | "invoice" | "contracts" | "emails";
  onClick: () => void;
};

const description = {
  "template-gallery": {
    description: "Explore commonly offered services with pricing guidance.",
    image: <TemplateGalleryIcon />,
    title: "Template Gallery",
  },
  invoice: {
    description: "Invoice generator to easily create and send invoices.",
    image: <InvoiceQuickToolsIcon />,
    title: "Invoice",
  },
  contracts: {
    description: "Create contracts in seconds with our templates.",
    image: <ContractsIcon />,
    title: "Contracts",
  },
  emails: {
    description: "Canned emails to easily communicate with clients.",
    image: <EmailsIcon />,
    title: "Emails",
  },
};

const bem = new BemHelper("quick-tools");

export const QuickTools: React.FC<Props> = ({ type, onClick }) => {
  const data = description[type];

  return (
    <div className={classNames(bem.block())} onClick={onClick}>
      {data.image}
      <div className={classNames(bem.element("description"))}>{data.description}</div>
      <div className={classNames(bem.element("link"))}>
        {data.title}
        <span>
          <ArrowQuickToolsIcon />
        </span>
      </div>
    </div>
  );
};
